<template>
  <li>
    <div class="panel">
      <div class="panel-body">
        <div class="form-horizontal">
          <div class="row">
            <div class="checkbox checkbox-primary col-sm-9">
              <input
                type="checkbox"
                name="opportunities[]"
                :value="{ id: opportunity.id }"
                :id="`checkbox-opportunity-${opportunity.id}`"
                v-model="stateOpportunities">
              <label :for="`checkbox-opportunity-${opportunity.id}`">
                {{ opportunity.name }}
              </label>
            </div>
            <div class="col-sm-3" v-if="this.opportunitiesWithBudget.includes(opportunity.name.toLowerCase())">
              <div :class="$hasErrorClass($v.stateOpportunityBudget, 'form-group')">
                <input type="text" placeholder="Budget" v-model="$v.stateOpportunityBudget.$model" class="form-control" @input="setBudget({id: opportunity.id })"/>
                <vuelidate-help label="Budget" :field="$v.stateOpportunityBudget"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul v-if="opportunity.children && opportunity.children.length > 0">
      <profile-talent-availability-child-opportunity-item
        v-for="childOpportunity in opportunity.children"
        :key="childOpportunity.id"
        :childOpportunity="childOpportunity"
        :opportunity="opportunity"
        :budgets="budgets"
        :opportunitiesWithBudget="opportunitiesWithBudget"
        @input="setBudget">
        <ul style="list-style: none;" v-if="childOpportunity.children && childOpportunity.children.length > 0">
          <profile-talent-availability-grand-child-opportunity-item
            v-for="grandchildOpportunity in childOpportunity.children"
            :key="grandchildOpportunity.id"
            :grandchildOpportunity="grandchildOpportunity"
            :opportunity="opportunity"
            :budgets="budgets"
            @input="setBudget"
          ></profile-talent-availability-grand-child-opportunity-item>
        </ul>
      </profile-talent-availability-child-opportunity-item>
    </ul>
  </li>
</template>

<script>
import { stateMapper } from 'mixins/users'
import { RegisterHelpers } from 'pickstar-common'
import {decimal} from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'
import ProfileTalentAvailabilityChildOpportunityItem from './ProfileTalentAvailabilityChildOpportunityItem'
import ProfileTalentAvailabilityGrandChildOpportunityItem from './ProfileTalentAvailabilityGrandChildOpportunityItem'

export default {
  data () {
    return {
      stateOpportunityBudget: null,
      opportunitiesWithBudget: ['social media post', 'be my brand/product ambassador', 'guest speaking', 'attend events']
    }
  },
  mounted () {
    this.budgets && this.budgets.map(x => {
      if (this.opportunity.id === x.opportunity_id) {
        this.$v.stateOpportunityBudget.$model = x.budget
        this.setBudget({id: x.opportunity_id})
      }
    })
  },
  validations () {
    return {
      stateOpportunityBudget: {
        decimal
      }
    }
  },
  mixins: [stateMapper],
  props: {
    opportunity: {
      required: true,
      type: Object
    },
    budget: {
      required: true,
      type: Array
    },
    budgets: {
      required: false,
      type: Array
    },
    opportunities: {
      type: Array,
      required: true
    }
  },
  methods: {
    checkInput (budget) {
      const pattern = /^\d+(\.\d{1,2})?$/
      return pattern.test(budget)
    },

    setBudget (budgetDetails) {
      let exist = this.budget.some(v => v.opportunity_id === budgetDetails.id)
      if (!exist) {
        if (!this.checkInput(budgetDetails.budget) && !this.checkInput(this.$v.stateOpportunityBudget.$model)) { return Promise.resolve() }
        this.budget.push({
          opportunity_id: budgetDetails.id,
          budget: budgetDetails.budget || this.$v.stateOpportunityBudget.$model,
          talent_id: this.user.id
        })
      } else {
        this.budget.find(v => v.opportunity_id === budgetDetails.id).budget = budgetDetails.budget || this.$v.stateOpportunityBudget.$model
      }
    },
    ...RegisterHelpers
  },
  components: {
    VuelidateHelp,
    ProfileTalentAvailabilityChildOpportunityItem,
    ProfileTalentAvailabilityGrandChildOpportunityItem
  }
}
</script>

<style>
  .budget-grand-children {
    margin-left: 3% !important;
  }
</style>
